module.exports = {"TXTWCL_All_Results":{"id":"TXTWCL_All_Results","defaultMessage":"Összes eredmény","track":"All Results"}}